import Constants from 'expo-constants';
import * as Application from 'expo-application';

const PRODUCTION_APP_SCHEME = 'tabbio';
const DEVELOPMENT_APP_SCHEME = 'tabbio-dev';
const STAGING_APP_SCHEME = 'tabbio-staging';

const APP_ID_SCHEMES: Record<string, string> = {
  'com.tabbio.app': PRODUCTION_APP_SCHEME,
  'com.tabbio.app.dev': DEVELOPMENT_APP_SCHEME,
  'com.tabbio.app.staging': STAGING_APP_SCHEME,
};

const VARIANT_SCHEMES: Record<string, string> = {
  development: DEVELOPMENT_APP_SCHEME,
  preview: STAGING_APP_SCHEME,
  prod: PRODUCTION_APP_SCHEME,
  production: PRODUCTION_APP_SCHEME,
  stage: STAGING_APP_SCHEME,
  staging: STAGING_APP_SCHEME,
};

function readExplicitAppScheme() {
  const value = process.env.EXPO_PUBLIC_APP_SCHEME;
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function readNativeApplicationScheme() {
  const applicationId = Application.applicationId;
  return applicationId ? (APP_ID_SCHEMES[applicationId] ?? null) : null;
}

function readVariantScheme() {
  const variant = process.env.EXPO_PUBLIC_APP_VARIANT?.trim().toLowerCase();
  return variant ? (VARIANT_SCHEMES[variant] ?? null) : null;
}

function readExpoScheme() {
  const rawScheme =
    (Constants.platform as { scheme?: string | string[] } | null)?.scheme ||
    Constants.expoConfig?.scheme;

  if (Array.isArray(rawScheme)) {
    return rawScheme[0] ?? null;
  }

  return typeof rawScheme === 'string' && rawScheme.trim()
    ? rawScheme.trim()
    : null;
}

function readExtraString(key: string) {
  const value = Constants.expoConfig?.extra?.[key];
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

export function getAppScheme() {
  return (
    readExplicitAppScheme() ||
    readNativeApplicationScheme() ||
    readVariantScheme() ||
    readExpoScheme() ||
    readExtraString('appScheme') ||
    PRODUCTION_APP_SCHEME
  );
}

export function getAcceptedAppSchemes() {
  return new Set([
    getAppScheme(),
    PRODUCTION_APP_SCHEME,
    DEVELOPMENT_APP_SCHEME,
    STAGING_APP_SCHEME,
  ]);
}
